const defaultState: any = []
const riskScoreReducer = (state = defaultState, action: any) => {
    switch (action.type) {
        case 'GENERATE_RISK_SCORE_LOADING':
            return { ...state, generateRiskScore: { ...state.generateRiskScore, loading: true } };
        case 'GENERATE_RISK_SCORE_SUCCESS':
            return { ...state, generateRiskScore: { ...state.generateRiskScore, loading: false, data: action.payload } };
        case 'GENERATE_RISK_SCORE_ERROR':
            return { ...state, generateRiskScore: { ...state.generateRiskScore, loading: false, error: true } };
        case 'CALCULATE_RISK_SCORE_LOADING':
            return { ...state, riskScoreData: { ...state.riskScoreData, loading: true } };
        case 'CALCULATE_RISK_SCORE_SUCCESS':
            return { ...state, riskScoreData: { ...state.riskScoreData, loading: false, data: action.payload } };
        case 'CALCULATE_RISK_SCORE_ERROR':
            return { ...state, riskScoreData: { ...state.riskScoreData, loading: false, error: true } };
        default:
            return state;
    }
}

export default riskScoreReducer;
